import { createRoot } from "react-dom/client";
import { AppRoot } from "./core/app-root.tsx";

if ("serviceWorker" in navigator) {
  const registerSw = () => {
    void navigator.serviceWorker
      .register("/sw.js", { scope: "/pro" })
      .catch(() => undefined);
  };
  if (document.readyState === "complete") registerSw();
  else window.addEventListener("load", registerSw, { once: true });
}

const root = document.getElementById("root");
if (!root) {
  throw new Error("Root element #root not found");
}

createRoot(root).render(<AppRoot />);
